import { DashReportComponent } from './dash-report/dash-report.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SpecialDealsReportComponent } from './special-deals-report/special-deals-report.component';
import { InvoicesReportComponent } from './invoices-report/invoices-report.component';

const routes: Routes = [
  { path: '', component: DashReportComponent },
  // { path: 'special-deals-report', component: SpecialDealsReportComponent },
  // { path: 'invoices-report', component: InvoicesReportComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
